// extracted by mini-css-extract-plugin
module.exports = {"lockedCustomerMessage":"UnlockBorrower_lockedCustomerMessage__AZ2h_"};